import { gql } from '@apollo/client';
export const QUESTIONNAIRE_DOWNLOAD_PDF = gql`
  mutation questionnaireDownloadPdf($questionnaireId: String!, $token: String, $fileName: String) {
    questionnaireDownloadPdf(questionnaireId: $questionnaireId, token: $token, fileName: $fileName) {
      mimeType
      fileName
      fileBase64
    }
  }
`;
